import { OshiraseService } from "@/service/OshiraseService";
import { OshiraseData } from "@/types/Oshirase";
import { computed, reactive, Ref, ref } from "vue";

/*
 * 初期処理
 */
export function useOshiraseList(oshiraseData: Ref<OshiraseData[]>) {
  let loading = ref(0);
  let isError = ref(false);

  const destroy = (target: OshiraseData) => {
    console.log('destroydestroydestroydestroy');

    const targetIndex = oshiraseData.value.findIndex(oshirase => oshirase.oshirase_id === target.oshirase_id)
    if (targetIndex >= 0) {
      oshiraseData.value.splice(targetIndex, 1);
    }
  }

  const getOshiraseList = async () => {
    loading.value++
    const dakokuService = new OshiraseService();
    const res = await dakokuService.getOshiraseList();
    if (res) {
      oshiraseData.value = res;
    }
    loading.value--
  }

  const getOshiraseSummary = async () => {
    loading.value++
    const dakokuService = new OshiraseService();
    const res = await dakokuService.getOshiraseSummary();
    if (res) {
      oshiraseData.value = res;
    }
    loading.value--
  }

  const isLoading = computed(() => {
    return !(loading.value === 0 || isError.value);
  });


  return {
    isLoading,
    destroy,
    getOshiraseList,
    getOshiraseSummary,
  }
}
